import { render } from "./index.vue?vue&type=template&id=68d223f8&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=68d223f8&lang=scss&scoped=true"

import exportComponent from "D:\\project\\php\\quick_wucode\\quick_wucode\\quickadmin\\vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68d223f8"]])

export default __exports__